import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate , useNavigate, useLocation} from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import SignIn from './components/SignIn';
import SessionOut from './components/SessionOut';
import Navbar from './components/Navbar';
import Agreements from './components/Agreements';
import RosterHistory from './components/RosterHistory';
import { useUser } from "./contexts/UserContext";
import { IdleTimerProvider } from 'react-idle-timer';
import User from './components/Admin/User';
import ContactInfo from './components/Admin/ContactInfo';
import { variables } from "./utility/variables";

function App() {
  
  const [isActiveUser, setIsActiveUser] = useState(false);
  const [userFullName, setUserFullName] = useState('user');
  const [isPAAdmin, setIsPAAdmin] = useState(false);
  const [isVendorAdmin, setIsVendorAdmin] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

 
  // useEffect(() => {
  //   validateuser(); 
  // });

  useEffect(() => {
    validateuser(); 
    const lastRoute = sessionStorage.getItem("lastRoute");
    console.log("APP.js lastRoute", lastRoute);
    // Redirect only if we're at root and lastRoute exists
    if (location.pathname === "/" && lastRoute && lastRoute !== "/") {
      navigate(lastRoute, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    // Always store the current route
    sessionStorage.setItem("lastRoute", location.pathname);
    
  }, [location]);

  const handleOnIdle = () => {
     // Clear session storage
     sessionStorage.clear();
     // Clear local storage
     localStorage.clear();
     setIsActiveUser(false);
    navigate("/SessionOut");
  };

  const validateuser = async () => {
    const response = await fetch(variables.API_URL + `User/validateuser`, {
          method: "GET",
          mode: "cors",
          credentials: "include", // important to send/set cookies
        });
        if (response.status === 401) {
          console.log('App.js: Unauthorized or session expired: Redirect to login');
          setIsActiveUser(false);
        }
        else {
          console.log('APP.js User/validateuser');
          const data = await response.json();
          if (data && data[0]) {
            console.log('User is authorized', data);
            setIsActiveUser(true);
            setUserFullName(data[0].FullName);
            if(data[0].RoleID === 3) setIsPAAdmin(true);
            if(data[0].RoleID === 2) setIsVendorAdmin(true);
          } else {
            setIsActiveUser(false);
          }  
        }
  }

  const signOut = async () => {
    // Clear session storage
    sessionStorage.clear();
    // Clear local storage
    localStorage.clear();
    const response = await fetch(variables.API_URL + `User/logout`, {
      method: "POST",
      credentials: "include" // logout and remove cookie
    })
    if (response.status === 401) {
      navigate('/signin');
    }
    const data = await response.json();
    console.log(data.message); // Logged out
    // Redirect to login page or clear app state
    window.location.href = "/signin";
     
  }

  return (
    <IdleTimerProvider
      timeout={60 * 60 * 1000} // 60 minutes
      onIdle={handleOnIdle}> 
      <div className='m-4 p-8'>
        {isActiveUser?<Navbar userFullName={userFullName} isPAAdmin={isPAAdmin} isVendorAdmin={isVendorAdmin} callback={signOut} />:<></>}
        <Routes>
          <Route index element={<Navigate to={isActiveUser ? "/agreements" : "/signin"} />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/agreements" element={<ProtectedRoute><Agreements /></ProtectedRoute>} />
          <Route path="/roster/:id" element={<ProtectedRoute><RosterHistory /></ProtectedRoute>} />
          <Route path="/admin/user" element={<ProtectedRoute><User /></ProtectedRoute>} />
          <Route path="/admin/contactinfo" element={<ProtectedRoute><ContactInfo /></ProtectedRoute>} />
          <Route path="/SessionOut" element={<SessionOut />} />
        </Routes>
      </div>
    </IdleTimerProvider>
  );
}

export default App;
